import { ca } from '@cian/analytics';

export function trackDownloadClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'B2BLanding',
    action: 'Download',
    label: 'ReportExample',
  });
}

export function trackLeaveClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'B2BLanding',
    action: 'Click',
    label: 'LeaveRequestTop',
  });
}
